import { z } from 'zod'
import type { CreateTaskCommand, TaskFormValues } from '../../types/domain'

const datePattern = /^\d{4}-\d{2}-\d{2}$/
const timePattern = /^([01]\d|2[0-3]):[0-5]\d$/

export const taskFormSchema = z.object({
  title: z.string().trim().min(1, 'Informe o título.').max(180, 'Use até 180 caracteres.'),
  description: z.string().trim().max(5000, 'Use até 5.000 caracteres.'),
  clientId: z.string().uuid('Selecione o cliente.'),
  assigneeId: z.string().uuid('Selecione o responsável.'),
  departmentId: z.string().uuid('Selecione o departamento.'),
  source: z.enum(['whatsapp', 'email', 'phone', 'in_person', 'other'], {
    error: 'Selecione a origem.',
  }),
  priority: z.enum(['normal', 'urgent'], {
    error: 'Selecione a prioridade.',
  }),
  periodicity: z.enum(['none', 'weekly', 'monthly', 'annual']),
  receivedDate: z.string().regex(datePattern, 'Informe a data de recebimento.'),
  receivedTime: z.string().regex(timePattern, 'Informe a hora de recebimento.'),
  dueDate: z.string().regex(datePattern, 'Informe a data do prazo.'),
  dueTime: z.union([z.literal(''), z.string().regex(timePattern, 'Informe uma hora válida.')]),
})

export function parseTaskForm(id: string, values: TaskFormValues): CreateTaskCommand {
  return { id, ...taskFormSchema.parse(values) }
}
